
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { capitalizeFirstLetter, decodeID, getLastURL, sidebarOpen } from '../../utils/Helper';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Spinner from '../../components/Spinner';
import { BillingManagementDetailAction } from '../../redux/Action/BillingAction';

const BillingManagementView = () => {
    const location = useLocation();
    const pathname = location.pathname;
    const pathSegments = pathname.split('/');


    const service_id = decodeID(pathSegments[3]);
    const booking_id = decodeID(pathSegments[2]);
    const dispatch = useDispatch<any>();
    const billing_details: any = useSelector((state: any) => state.BillingManagementDetailState)


    
    useEffect(() => {
        dispatch(BillingManagementDetailAction({ service_id, booking_id }))
    }, [])

    const breadcrumbItems = [
        { title: 'dashboard', link: '/dashboard' },
        { title: 'billing_List', link: '/billing' },
        { title: 'View_billing_management' }
    ];

    const [data, setData]: any = useState([]);

    useEffect(() => {
        if (billing_details?.status && billing_details?.data?.data) {
            setData(billing_details?.data?.data)
        }
    }, [billing_details])



    return (
        <>
            <div className='col-lg-9 serviceMemberList'>
                {billing_details?.loading ? <Spinner /> : ""}
                <div className='dashboard bg-white'>
                    <div className='dashboardTop'>
                        <h2><button type='button' className='btn mobileMenu p-1 d-lg-none' onClick={() => { sidebarOpen() }} ><span className="icon-menu-right"></span></button> <FormattedMessage id="billing_management" /></h2>
                        <Breadcrumb items={breadcrumbItems} />
                    </div>
                    <div className='dashboarcard'>
                        <div className='row gy-4 row-cols-1 row-cols-sm-3 row-cols-lg-6 serviceViewtop'>
                            <div className='col'>
                                <h6><FormattedMessage id="service_name" /></h6>
                                <p>{data?.service_details?.name ? data?.service_details?.name : "N/A"}</p>
                            </div>
                            <div className='col'>
                                <h6><FormattedMessage id="service_duration" /></h6>
                                <p>{data?.service_details?.duration ? data?.service_details?.duration : "N/A"}</p>
                            </div>

                            <div className='col'>
                                <h6><FormattedMessage id="user_name" /></h6>
                                <p>{data?.user_details?.name ? `${data?.user_details?.name}` : "N/A"}</p>
                            </div>
                            <div className='col'>
                                <h6><FormattedMessage id="phone_number" /></h6>
                                <p>{data?.user_details?.name ? `${data?.user_details?.phone_country_code + " " + data?.user_details?.phone_number}` : "N/A"}</p>
                            </div>
                            <div className='col'>
                                <h6><FormattedMessage id="email" /></h6>
                                <p>{data?.user_details?.email ? data?.user_details?.email : "N/A"}</p>
                            </div>


                        </div>

                        <div className='about my-4'>
                            <p>{data?.service_details?.description ? data?.service_details?.description : "N/A"}</p>
                        </div>



                    </div>
                </div>
            </div>
        </>
    )
}

export default BillingManagementView